import checkout from "layouts/organization/components/organization-details/schemas/organizationForm";

const {
  formField: { organizationKey, isPhonicsEnabled },
} = checkout;

export default {
  [organizationKey.name]: "",
  [isPhonicsEnabled.name]: false,
};
